import $ from "jquery";
import "slick-carousel";

const sliderProductSlick = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    $(function () {
      const sliderWrappers = $(".js-wrapper-card-slick");

      sliderWrappers?.each((index, sliderWrapper) => {
        // console.log(sliderWrapper);
        const prevArrow = $(sliderWrapper).parent().find(".arrow-left");
        const nextArrow = $(sliderWrapper).parent().find(".arrow-right");

        $(sliderWrapper).slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          infinite: false,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                variableWidth: false,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: false,
              },
            },
            {
              breakpoint: 601,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: false,
              },
            },
          ],
        });
      });
    });
  };

  init();
};

try {
  sliderProductSlick();
} catch (error) {
  console.log(error);
}
